import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-strikethrough-icon',
  templateUrl: './text-strikethrough.component.html'
})
export class TextStrikethroughComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
